import { observable, computed, action, makeObservable } from 'mobx';
import { dataManagerFactory, configurationsStore } from 'utils/MobxDataManager/singletons';
import { IManagerDataManager, ITeamCycleManager } from 'typings/dataManagers';

export class SummaryDashboardStore {
    @observable private _overviewSummary: ITeamOverviewSummary;
    private _masterAccountId: string;
    private _managerDataManager: IManagerDataManager;
    private _teamCycleManager: ITeamCycleManager;

    constructor(masterAccountId: string) {
        makeObservable(this);
        this._masterAccountId = masterAccountId;
        this._managerDataManager = dataManagerFactory.getManagerDataManager();
        this._teamCycleManager = dataManagerFactory.getTeamCycleManager();
        this._overviewSummary = {
            workflowSummary: [] as IStatusSummary[],
            basePayRangeSummary: [] as IStatusSummary[],
            promotionRequestSummary: [] as IStatusSummary[],
            budgetStatistics: [] as IBudgetSummary[],
            managerOverBudgetSummaries: [] as IManagerOverBudgetSummary[]
        } as ITeamOverviewSummary;

        this.exportAllManagersToCsv = this.exportAllManagersToCsv.bind(this);
    }

    @computed
    get overviewSummary(): ITeamOverviewSummary {
        return this._overviewSummary;
    }

    @computed
    get allManagersCount(): number {
        return this._overviewSummary && this._overviewSummary.workflowSummary ?
            this._overviewSummary.workflowSummary.reduce((accumulator, summary) =>
                accumulator + summary.statusCount, 0) :
            0;
    }

    @action
    async fetchTeamOverviewSummary(): Promise<void> {
        const overviewSummary = await this._teamCycleManager.getTeamOverviewSummary(
            this._masterAccountId,
            configurationsStore.currentCycleId
        );
        if (overviewSummary) {
            this._overviewSummary = overviewSummary;
        }
    }

    async exportAllManagersToCsv(): Promise<void> {
        await this._managerDataManager.exportAllManagersToCsv(
            this._masterAccountId,
            configurationsStore.currentCycleId
        );
    }
}